const SEPARATOR = '/'
const BASE_URL_REG_EXP = new RegExp(`^(http:|https:|${SEPARATOR})`)
const LAST_SEPARATOR_REG_EXP = new RegExp(`(.+)${SEPARATOR}$`)

export const isBaseUrl = (url) => BASE_URL_REG_EXP.test(url)

const replaceLastSeparator = (path) => path.replace(LAST_SEPARATOR_REG_EXP, '$1')

export const join = (base, path) => (isBaseUrl(path) ? path : [replaceLastSeparator(base), path].join(SEPARATOR))
